import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["activeCategory"]

  connect() {
    if (this.hasActiveCategoryTarget && window.matchMedia("(max-width: 860px)").matches) {
      this.activeCategoryTarget.scrollIntoView({ block: "nearest", inline: "nearest" })
    }
  }
}
